import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type CheckMarkIcon2Props = Partial<SVGIconProps>;

const CheckMarkIcon2: FC<CheckMarkIcon2Props> = (props) => (
  <SVGIcon fill="none" height="28" viewBox="0 0 31 28" width="31" {...props}>
    <path
      clipRule="evenodd"
      d="M27.0296 1.47509L9.42791 18.7501L4.75708 13.6751C3.89666 12.8501 2.54458 12.8001 1.56124 13.5001C0.602493 14.2251 0.332075 15.5001 0.922075 16.5251L6.45332 25.6751C6.99416 26.5251 7.92832 27.0501 8.98541 27.0501C9.99332 27.0501 10.9521 26.5251 11.4929 25.6751C12.3779 24.5001 29.2667 4.02509 29.2667 4.02509C31.4792 1.72509 28.7996 -0.299906 27.0296 1.45009V1.47509Z"
      fill="#255F41"
      fillRule="evenodd"
    />
  </SVGIcon>
);

export default CheckMarkIcon2;
